import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { authReducer } from '.';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './_effects/auth.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('auth', authReducer),
    EffectsModule.forFeature([AuthEffects])
  ],
  declarations: []
})
export class AuthModule {}
